export default __webpack_public_path__ + "static/media/line_item_table_icon.00a90dc8.svg";